import { Icon } from '@livable/saas-react-components';
import React from 'react';
import { formatUtilityLabel } from 'src/pages/NewBillingModule/ApplyBillingFull/BillAutomationExtraction';
import useStyles from './billDetailsStyles';
import { getServiceIndexes, getServiceTypes } from './billUtilityMatching';
import { PropertyLineItems } from './PropertyLineItems';
function formatList(items) {
  if (items.length < 2) return items[0] || '';
  return "".concat(items.slice(0, -1).join(', '), " and ").concat(items[items.length - 1]);
}

/**
 * What the bill charges for that the property is not set up for (Figma: bills carrying stormwater or
 * an unnamed "Other" line). These charges are left out of the summary and the allocation tables, so
 * they are shown here instead of silently disappearing from a bill the user is reading.
 */
export function ExtraUtilitiesCard(_ref) {
  let currency = _ref.currency,
    data = _ref.data,
    _ref$getGlAccountLabe = _ref.getGlAccountLabelFor,
    getGlAccountLabelFor = _ref$getGlAccountLabe === void 0 ? null : _ref$getGlAccountLabe,
    groups = _ref.groups,
    _ref$showGlCode = _ref.showGlCode,
    showGlCode = _ref$showGlCode === void 0 ? false : _ref$showGlCode;
  const classes = useStyles();
  const utilities = getServiceTypes(groups).map(formatUtilityLabel);
  const isPlural = utilities.length > 1;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.card
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.cardHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.cardHeaderTitles
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.cardTitle
  }, "Other utilities on this bill"), /*#__PURE__*/React.createElement("span", {
    className: classes.statusChip
  }, "Not allocated"))), /*#__PURE__*/React.createElement("div", {
    className: classes.summary
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.matchBox, " ").concat(classes.matchBoxWarning)
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "warning",
    type: "warning"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.matchTitle, " ").concat(classes.matchTitleWarning)
  }, "This bill covers ", isPlural ? 'utilities' : 'a utility', " the property is not set up for"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.matchText, " ").concat(classes.matchTextWarning)
  }, formatList(utilities), " ", isPlural ? 'are' : 'is', " not configured on the matched", ' ', groups.length > 1 ? 'properties' : 'property', ", so ", isPlural ? 'they are' : 'it is', " left out of the bill summary and the allocation suggestions. Set ", isPlural ? 'them' : 'it', " up on the property to allocate these charges."))), /*#__PURE__*/React.createElement("div", {
    className: classes.sectionLabel
  }, "Line items by property:")), groups.map(group => {
    var _data$properties;
    return /*#__PURE__*/React.createElement(PropertyLineItems, {
      currency: currency,
      data: data
      // Left out of the allocation, not out of the payable: the push still has to resolve an account
      // for these lines, and where there is none it blocks, so each says so here and where to set it.
      ,
      getGlAccountLabel: getGlAccountLabelFor ? getGlAccountLabelFor(group.propertyIndex) : null,
      glAccountPropertyId: (data === null || data === void 0 || (_data$properties = data.properties) === null || _data$properties === void 0 || (_data$properties = _data$properties[group.propertyIndex]) === null || _data$properties === void 0 ? void 0 : _data$properties.propertyId) || null,
      key: group.propertyIndex,
      propertyIndex: group.propertyIndex,
      serviceIndexes: getServiceIndexes(group),
      showGlCode: showGlCode
    });
  }));
}